// isCampo.js
export function isCampo(schedule) {
    const lowerTestType = (schedule.testType || '').toLowerCase();
    const lowerTipoMarca = (schedule.tipoMarca || '').toLowerCase();
    return lowerTestType.includes('campo') || lowerTipoMarca.includes('campo');
  }
  